import DashboardLayout from "@/views/LayoutView/DashboardLayout.vue";

import EditPaper from "@/views/SubmissionView/EditPaper.vue";
import SubmitAgreement from "@/views/SubmissionView/SubmitAgreement.vue";
import PaperDetail from "@/views/SubmissionView/PaperDetail.vue";
import SubmissionManagement from "@/views/SubmissionView/SubmissionManagement.vue";
import AllSubmissionsManagement from "@/views/SubmissionView/AllSubmissionsManagement.vue";
import SelectJournal from "@/views/SubmissionView/SelectJournal.vue";

const submissionsMenu = {
  path: "/submissions",
  component: DashboardLayout,
  name: "Submission",
  children: [
    {
      path: "edit/:idx",
      name: "submission-edit",
      component: EditPaper,
      props: true,
      meta: { requiresAuth: true, title: "topnav.submit_paper" },
    },
    {
      path: "/:journalIdx/agreement",
      name: "submission-agreement",
      component: SubmitAgreement,
      props: true,
      meta: { requiresAuth: true, title: "topnav.submission_agreement" },
    },
    {
      path: "all",
      name: "submission-all",
      component: AllSubmissionsManagement,
      meta: {
        requiresAuth: true,
        title: "topnav.all_submission_status",
        requiredMemberType: ["ADMIN"],
      },
    },
    {
      path: "status",
      name: "submission-status",
      component: SubmissionManagement,
      meta: { requiresAuth: true, title: "topnav.my_submission" },
    },
    {
      path: "detail/:idx",
      name: "submission-detail",
      component: PaperDetail,
      props: true,
      meta: { requiresAuth: true, title: "topnav.submission_detail" },
    },
    {
      path: "create/journal",
      name: "select-journal",
      component: SelectJournal,
      meta: { requiresAuth: true, title: "topnav.submission_select_journal" },
    },
  ],
};

export default submissionsMenu;
